<template>
  <v-layout  column fill-height>         
   <div class="!grow-0 flex flex-wrap items-center">    
     <div  class="flex-grow-0" style="border:1px solid #ccc;border-bottom: 0px;border-top: 0px;border-left:0px ;">        
       <v-btn v-if="!allMissionVisibility" class="mx-0" icon @click.prevent="$store.myActions.UI_SHOW_ALL_SIMULATION_MISSION_MAP();" :title="$t('Pilot.MissionDrawer.ShowAllListedMissionTooltip')" ><v-icon>mdi-eye-off</v-icon></v-btn>  
       <v-btn v-if="allMissionVisibility" class="mx-0" icon @click.prevent="$store.myActions.UI_HIDE_ALL_SIMULATION_MISSION_MAP();" :title="$t('Pilot.MissionDrawer.HideAllListedMissionTooltip')" ><v-icon>mdi-eye</v-icon></v-btn>  
     </div>
     <h2 class="py-2 ml-4" v-if="infosSimMission" > {{ missionGlobal.MIG_LIBELLE }} #{{ infosSimMission.libelle.replace(`${missionGlobal.MIG_KEY}_`,'') }}</h2>
     <h2 class="py-2 ml-4" v-else > {{ missionGlobal.MIG_LIBELLE }} {{ $t("Simulation.Current") }}</h2>
   </div>
   <div class="!grow-0 flex flex-col pa-2 text-xs" style="background-color: #eee;">      

      <table class="mrs-tbl" cellspacing="0">
          <thead>
            <tr>          
              <td>{{$t("Simulation.ProcessingState")}}</td>
              <td>{{$t("Simulation.ProcessingTime")}}</td>
              <td>{{$t("Simulation.EstimatedMissionEndDate")}}</td>                         
            </tr>
          </thead>
          <tr>
              <td><span class="data" v-if="infosSimMission && infosSimMission.result">{{$t(simulationStatusKey) }}</span></td>
              <td><span class="data" v-if="infosSimMission && infosSimMission.result && infosSimMission.result.processing_time">{{  $options.filters.formatDuration(infosSimMission.result.processing_time * 1000,true) }}</span></td>
              <td><span class="data" v-if="infosSimMission && infosSimMission.result">{{ $options.filters.formatDate(infosSimMission.result.mission_end_date,"DD/MM/YYYY HH:mm") }}</span></td>
            </tr>
        </table>            
   </div>
   <div class="grow flex" style="position:relative" >      
       <div ref="liste" class="drawer-container flex flex-col " :style="{overflow:simMissions.length <= 24?'auto':'none'}" v-if="simMissions.length > 0">
         <!-- Zone liste de résultats -->                                    
         <auto-virtual-scroll-list        
              v-if="simMissions.length > 24"  
             v-resize="onResize" :totalHeight="height"
             :defaultHeight="36"
             :extra-items="5"
             style="width: 100%;">    
                <SimulationCurrentLine />
               <SimulationMissionLine v-for="simulation in simMissions"  :key="simulation.id" :uiid="buildMissionUIStateId(simulation.id)" :mission="simulation" />                                                                       
           </auto-virtual-scroll-list>
           <div v-else >
             <SimulationCurrentLine />
             <SimulationMissionLine v-for="simulation in simMissions" :key="simulation.id" :uiid="buildMissionUIStateId(simulation.id)" :mission="simulation" />                       
           </div>                  
       </div>    
       <div v-else class="flex items-center justify-center !grow">
        {{$t('Simulation.NoSimulation')}} <br/>
       </div>       
   </div> 
 </v-layout> 
</template>
<script lang="ts">

import { AloDbMissionGlobal } from '@/models/alodb/AloDbMissionGlobal'
import { SimulationUiState, buildSimulationUIStateId } from '@/models/ui/SimulationUiState'
import SimulationMissionLine from '@/components/smart/SimulationMissionLine.vue'
import SimulationCurrentLine from '@/components/smart/SimulationCurrentLine.vue'

import Vue from 'vue'
import Component from 'vue-class-component'
import {buildMissionUIStateId} from '@/models/ui/MissionUiState'  
import { MapUiState } from '@/models/ui/MapUiState'
import { AloDbMissionVirtual } from '@/models/alodb/AloDbMissionVirtual'
import {getSimulationStatusTradKey} from '@/enum/SimulationStatus'
 
@Component({
name: 'SimulationDetailDrawer',
components:{SimulationMissionLine,SimulationCurrentLine}
})
export default class SimulationDetailDrawer extends Vue {      
  

 get missionGlobal(){
   return this.$store.myGetters.originalAdmMissionGlobal
 }

 get map_uiid(){
   return buildSimulationUIStateId(this.missionGlobal.MIG_ID!,'map')
 }

 get mapState() { 
   //retourne un MapUiState    
   return this.uistatebyuiid(this.map_uiid) as MapUiState         
 }

 get simulationStatusKey(){
    return getSimulationStatusTradKey(this.infosSimMission.VIM_STATUS)
 }

 get bestFitMisId(){
   return this.mapState?.bestFitMisId
 }

 get infosSimMission() {
   return this.missionVirtualsById[this.bestFitMisId]
 }

 get simulation_uiid() {
   return buildSimulationUIStateId(this.missionGlobal.MIG_ID!,"detail")
 }

 get uistatebyuiid(){
   return this.$store.myGetters.uistatebyuiid
 }

 get allMissionVisibility(){
   return this.$store.myGetters.allMissionVisibility
 }
 
 //recupere le state de travail
 get simulationState() { 
   //retourne un MapUiState    
   return this.uistatebyuiid(this.simulation_uiid) as SimulationUiState       
 }

 get isRunnable()
 {
   return true
 }

 get missionVirtualsById(){
   return this.$store.myGetters.missionVirtualsById
 }

 get simMissions(){
   return this.missionGlobal.misIdArray.map(id => this.missionVirtualsById[id]).filter(m => !!m).sort((s1,s2)=>s2.id! - s1.id!) as Array<AloDbMissionVirtual>
 }

 height = 100

 buildMissionUIStateId(missionId:number, typeUiid="detail") {
   return buildMissionUIStateId(missionId,typeUiid)
 }

 mounted(){
   this.onResize()
 }

 onResize() {
   //@ts-ignore
   if(this.$refs.liste) this.height = this.$refs.liste.clientHeight        
 }
 
}
</script> 

<style scope>  
 .header-list{
   flex: 0 0 auto;
 }
 .filter{
   flex: 0 0 auto;    
   height: min-content;
   background-color: #eee;
 }
.liste {
   flex: 1 1 auto;
   overflow: hidden;
   height: min-content;
 }  
</style>